// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul {
  margin-top: 0;
  margin-bottom: 0;
}

a {
  color: var(--fs-green);
  font-weight: bold;
}
a:visited {
  color: #6a5147;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJlY3Vyc2l2ZS1saXN0LmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0ksYUFBQTtFQUNBLGdCQUFBO0FBQ0o7O0FBRUE7RUFDSSxzQkFBQTtFQUNBLGlCQUFBO0FBQ0o7QUFBSTtFQUNFLGNBQUE7QUFFTiIsImZpbGUiOiJyZWN1cnNpdmUtbGlzdC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbInVsIHtcbiAgICBtYXJnaW4tdG9wOiAwO1xuICAgIG1hcmdpbi1ib3R0b206IDA7XG59XG5cbmEge1xuICAgIGNvbG9yOiB2YXIoLS1mcy1ncmVlbik7XG4gICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gICAgJjp2aXNpdGVkIHtcbiAgICAgIGNvbG9yOiAjNmE1MTQ3O1xuICAgIH1cbn0iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/buy-permits/step-components/permit-information/recursive-list/recursive-list.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,gBAAA;AACJ;;AAEA;EACI,sBAAA;EACA,iBAAA;AACJ;AAAI;EACE,cAAA;AAEN;AACA,wjBAAwjB","sourcesContent":["ul {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\na {\n    color: var(--fs-green);\n    font-weight: bold;\n    &:visited {\n      color: #6a5147;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
